/**
 * action types
 */
export const UPDATE_COURSES = 'UPDATE_COURSES';
export const FETCH_COURSE_OUTCOMES = 'FETCH_COURSE_OUTCOMES';
export const RETRIEVE_COURSE_OUTCOMES = 'RETRIEVE_COURSE_OUTCOMES';
export const START_SET_COURSE_OBJECTIVE_AND_OUTCOMES =
  'START_SET_COURSE_OBJECTIVE_AND_OUTCOMES';
export const FINISH_SET_COURSE_OBJECTIVE_AND_OUTCOMES =
  'FINISH_SET_COURSE_OBJECTIVE_AND_OUTCOMES';
export const SET_COURSE_MODULES = 'SET_COURSE_MODULES';
export const CREATE_MODULE_TO_COURSE_MODULE_SET =
  'CREATE_MODULE_TO_COURSE_MODULE_SET';
export const DELETE_MODULE_FROM_COURSE = 'DELETE_MODULE_FROM_COURSE';
export const UPDATE_MODULE_DATA = 'UPDATE_MODULE_DATA';
export const COURSE_ADD_ADMIN = 'COURSE_ADD_ADMIN';
export const SET_COURSE_LANDING_PAGE_DATA = 'SET_COURSE_LANDING_PAGE_DATA';

export const CREATE_COURSE_START = 'CREATE_COURSE_START';
export const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS';
export const CREATE_COURSE_FAILURE = 'CREATE_COURSE_FAILURE';
export const CREATE_COURSE_FAILURE_NON_EDUCATOR =
  'CREATE_COURSE_FAILURE_NON_EDUCATOR';
export const CREATE_COURSE_BUTTON_CLICKED = 'CREATE_COURSE_BUTTON_CLICKED';

export const FETCH_COURSE_MODULES_START = 'FETCH_COURSE_MODULES_START';
export const FETCH_COURSE_MODULES_SUCCESS = 'FETCH_COURSE_MODULES_SUCCESS';
export const FETCH_COURSE_MODULES_FAILURE = 'FETCH_COURSE_MODULES_FAILURE';
